import React from 'react';
import { View } from 'react-native';

import { VFText } from '@vfgroup-oneplatform/foundation/Components';
import { withTheme, LightThemeColors } from '@vfgroup-oneplatform/foundation/Components/Themes';
import VFLottieView from '@vfgroup-oneplatform/foundation/Components/VFLottieView';
import PropTypes from 'prop-types';

import LoginTestKeys from '../../Utils/LoginTestKeys';

import styles from './LoadingAnimation.Styles';

function LoadingAnimation({ loadingText, theme }) {
  return (
    <View style={styles.container}>
      <VFLottieView
        autoPlay
        lottieViewStyle={styles.lottieView}
        testID={LoginTestKeys.loadingIndicator}
      />
      <View style={styles.textContainer}>
        <VFText
          i18nKey={loadingText}
          style={styles.text(theme)}
          testID={LoginTestKeys.loadingText}
        />
      </View>
    </View>
  );
}

LoadingAnimation.defaultProps = {
  theme: LightThemeColors,
};

LoadingAnimation.propTypes = {
  loadingText: PropTypes.string,
  theme: PropTypes.shape({
    name: PropTypes.string,
    isDark: PropTypes.bool,
    colors: PropTypes.object,
  }),
};

export default withTheme(LoadingAnimation);
